import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from 'utils'

export const payrollDetails = createAsyncThunk('payroll/details', async ({ id, pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `payroll/${id}`,
            params: {
                year_id: data?.year_id,
                month: data?.month,
                premise_id: data?.premise_id,
            },
            headers: {
                'Content-Type': 'application/json',
                Authorization: SessionManager.getCookie('user_token'),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const payrollList = createAsyncThunk('payroll/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'payroll',
            params: {
                year_id: data?.year_id,
                month: data?.month,
                premise_id: data?.premise_id,
                search: data?.search,
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
            },
            headers: {
                'Content-Type': 'application/json',
                Authorization: SessionManager.getCookie('user_token'),
            },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const payroll = createSlice({
    name: 'payroll',
    initialState: {
        list: [],
        details: null,
        loading: false,
        detailsLoading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(payrollList.pending, (state) => {
            state.loading = true
        })
        builder.addCase(payrollList.fulfilled, (state, action) => {
            state.loading = false
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data || []
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
        builder.addCase(payrollList.rejected, (state) => {
            state.loading = false
            state.list = []
        })

        builder.addCase(payrollDetails.pending, (state) => {
            state.detailsLoading = true
        })
        builder.addCase(payrollDetails.fulfilled, (state, action) => {
            state.detailsLoading = false
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
        builder.addCase(payrollDetails.rejected, (state) => {
            state.detailsLoading = false
            state.details = null
        })
    },
})

export default payroll.reducer
